import brandPortalAccountRoute from "@faire/web-api/routes/brand-portal/account";
import articlePage from "@faire/web-api/routes/support/articles/articleId";
import { Button } from "@faire/web/slate/Button";
import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var TaxForm1099IA = function TaxForm1099IA(_ref) {
  var brand = _ref.brand;
  if ((brand === null || brand === void 0 ? void 0 : brand.based_in) === "USA") {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "EkqTdQ",
      defaultMessage: [{
        "type": 0,
        "value": "In order to receive a 1099-K tax form you must meet "
      }, {
        "children": [{
          "type": 0,
          "value": "certain sales thresholds"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " on Faire. Once you confirm you meet those thresholds, you can view and download your 1099-K tax form, by following these steps:"
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return CertainSaleLinkFormatting(chunks);
        },
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
      step: 1
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "VPbiI1",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "For electronic delivery:"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "9JoO7p",
      defaultMessage: [{
        "type": 0,
        "value": "If you opted for electronic delivery, you can find your 1099-K tax form in "
      }, {
        "children": [{
          "type": 0,
          "value": "Account settings"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": " under the "
      }, {
        "children": [{
          "type": 0,
          "value": "Export & Taxes"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " page in the Faire portal. It will be available as soon as it’s ready, typically before 31 January."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "export-taxes");
        },
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(LiItem, {
      step: 2
    }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "Bnijx1",
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "For physical mail delivery:"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "+2dQY7",
      defaultMessage: [{
        "type": 0,
        "value": "If you requested a physical copy, it should be delivered by mid-February. Ensure that your taxpayer details and legal address are up to date in your "
      }, {
        "children": [{
          "type": 0,
          "value": "Export & Taxes"
        }],
        "type": 8,
        "value": "LinkFormatting"
      }, {
        "type": 0,
        "value": " settings to avoid any delays."
      }],
      values: {
        LinkFormatting: function LinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "export-taxes");
        }
      }
    })))));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Qdu8Ar",
    defaultMessage: [{
      "type": 0,
      "value": "You won’t receive a 1099-K from Faire, as these are only sent to brands based in the US. If you are based in the US and believe that you should have received a form, please contact us below."
    }]
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var CertainSaleLinkFormatting = function CertainSaleLinkFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: articlePage("360022603552"),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};